<app-html-news [news]="news"></app-html-news>
